import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, ICollapsibleMenuProps } from '@agilepoint/wat-react-ux';
import { useConfigScopeSelectors } from 'modules/core/scopes';
import { MenuItemsContext } from '../providers/context';
import styled from 'styled-components';
import { useTranslate } from '@agilepoint/wat-react';
import { INavigationMenuItem } from 'types';

interface IExtendedNavigationMenuProps extends ICollapsibleMenuProps {
}

const StyledCollapsibleMenu = styled(Menu.CollapsibleMenu)`
    flex: 1;
    .ap-collapsibleMenu-itemWrapper {
        border-radius: ${(props)=>props.theme.semantics.borderRadius.curvedLarge};
        height: 36px;
        box-sizing: border-box;
        margin: 5px 0px;
    }

    .ap-treeView-itemsWrapper {
        padding: 15px 10px;
    }

    .ap-treeview-modeIndicator {
        width: 30px;
        height: 30px;
    }
`;

const helpNavBarId = 'help';

function useTranslatedMenuItem(): INavigationMenuItem[] {
    const translate = useTranslate();
    const { menuItems } = React.useContext(MenuItemsContext);
    return menuItems.map(item => ({
            ...item,
            label: translate(item.label ? item.label : '')
        }));
}

export const NavigationMenuBase = React.memo((props: Partial<IExtendedNavigationMenuProps>) => {
    const navigate = useNavigate();
    const location = useLocation();
    const translatedMenuItems = useTranslatedMenuItem();
    const [, moduleName] = location.pathname.split('/');
    const [selectedId, setSelectedId] = React.useState(moduleName);

    const { selectMobileAppAcceleratorConfig } = useConfigScopeSelectors();
    const { navHelpLink } = selectMobileAppAcceleratorConfig();

    React.useEffect(() => {
        setSelectedId(moduleName);
    }, [moduleName]);

    const onChange = React.useCallback((currentSelectedId: string) => {
        let selectedRoute = currentSelectedId;
        if (currentSelectedId === helpNavBarId) {
            window.open(navHelpLink);
            selectedRoute = selectedId;
        }
        else {
            navigate(`/${currentSelectedId}`);
        }
        setSelectedId(selectedRoute);
    }, [navigate, navHelpLink, selectedId]);

    return (
        <StyledCollapsibleMenu {...props}
            items={translatedMenuItems}
            onChange={onChange}
            selectedId={selectedId}
            disableModeChangeOnHover
            highlightSelectionPath
        />
        );
});
